import { render, staticRenderFns } from "./base-info.vue?vue&type=template&id=86799612&scoped=true"
import script from "./base-info.vue?vue&type=script&lang=js"
export * from "./base-info.vue?vue&type=script&lang=js"
import style0 from "./base-info.vue?vue&type=style&index=0&id=86799612&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86799612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86799612')) {
      api.createRecord('86799612', component.options)
    } else {
      api.reload('86799612', component.options)
    }
    module.hot.accept("./base-info.vue?vue&type=template&id=86799612&scoped=true", function () {
      api.rerender('86799612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/intercity/base-info.vue"
export default component.exports